import React from 'react'

const Four0Four = () => {
  return (
    <div>
      
    </div>
  )
}

export default Four0Four
